import React, { useState, useEffect } from "react";
import LoginPage from "./LoginPage";
import MainPage from "./MainPage"; // Your MQTT page

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = sessionStorage.getItem("loggedInUser");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLoginSuccess = (userDetails) => {
    sessionStorage.setItem("loggedInUser", JSON.stringify(userDetails));
    setUser(userDetails);
  };

  return (
    <>
      {!user ? (
        <LoginPage onLoginSuccess={handleLoginSuccess} />
      ) : (
        <MainPage userDetails={user} />
      )}
    </>
  );
}

export default App;
